import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c43cafbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "sw-text-field--label"
}
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["id", "placeholder", "disabled", "name", "type"]

import {
  computed,
  withDefaults,
  getCurrentInstance,
} from 'vue';
import SwIcon from '@/components/molecules/Icons/SwIcon.vue';
import { IconType, TextFieldType } from '@/types/ui-components';

interface Emits {
  (e: 'update:modelValue', data: string): void;
  (e: 'clickAppendIcon', data: string): void;
}
interface Props {
  label?: string;
  type?: TextFieldType;
  name?: string;
  id?: string;
  placeholder?: string;
  color?: 'primary';
  disabled?: boolean;
  appendIcon?: IconType;
  hasError?: boolean;
  // v-model properties
  modelValue?: string;
  isRequired?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwTextField',
  props: {
    label: { default: undefined },
    type: { default: 'text' },
    name: { default: undefined },
    id: { default: undefined },
    placeholder: { default: undefined },
    color: { default: 'primary' },
    disabled: { type: Boolean, default: false },
    appendIcon: { default: undefined },
    hasError: { type: Boolean, default: false },
    modelValue: { default: '' },
    isRequired: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "clickAppendIcon"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', data: string): void;
  (e: 'clickAppendIcon', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { label: string, type: TextFieldType, name: string, id: string, placeholder: string, color: 'primary', disabled: boolean, appendIcon: IconType, hasError: boolean, modelValue: string, isRequired: boolean }





/**
 * uidを取得
 */
const uid = computed(() => {
  if (props.id) return props.id;

  const val = getCurrentInstance()?.uid;
  return `sw-text-field-${val?.toString()}`;
});

/**
 * 入力値
 */
const valueComputed = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  },
});

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-text-field': true,
  'sw-text-field--has-append-icon': !!props.appendIcon,
  'sw-text-field--has-error': props.hasError,
}));

const onCkickIcon = () => {
  emit('clickAppendIcon', '');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("label", { for: _unref(uid) }, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(__props.label), 1),
            (__props.isRequired)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        class: "sw-text-field--input",
        id: _unref(uid),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueComputed) ? (valueComputed).value = $event : null)),
        placeholder: __props.placeholder,
        disabled: __props.disabled,
        name: __props.name,
        type: __props.type
      }, null, 8, _hoisted_4), [
        [_vModelDynamic, _unref(valueComputed)]
      ]),
      (__props.appendIcon)
        ? (_openBlock(), _createBlock(SwIcon, {
            key: 1,
            icon: __props.appendIcon,
            size: "medium",
            color: "primary",
            onClick: onCkickIcon
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1)
  ], 2))
}
}

})